<template>
  <div class="content-container">
    <el-breadcrumb separator="/" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        v-if="origin == 1"
        :to="{ path: '/dashboard/dealer/orders' }"
        >报价单列表</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="order" :to="parentRouter.path">{{
        parentRouter.name
      }}</el-breadcrumb-item>
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel mt-20" v-if="order">
      <div class="order-option-header mb-15">
        <h6 style="display: flex; align-items: center">
          报价编号：{{ order.number }}
          <el-tag
            size="small"
            class="ml-10"
            :type="orderStatusMap[order.status].type"
            >{{ orderStatusMap[order.status].name }}</el-tag
          >
        </h6>
        <div>
          <div>
            <template v-if="canEdit"
              ><router-link
                class="mr-10"
                :to="
                  `/dashboard/${
                    this.order.customer_user_id > 0
                      ? 'consult_order_editor'
                      : 'order_editor'
                  }?order=` + order.id
                "
                v-permission="Auth.orderEdit"
              >
                <el-button icon="el-icon-edit" size="small" type="primary" plain
                  >编辑</el-button
                >
              </router-link>
              <el-button
                icon="el-icon-edit"
                size="small"
                type="danger"
                plain
                v-if="order.customer_user_id == 0"
                @click="deleteOrder()"
                v-permission="Auth.orderDelete"
                >删除</el-button
              ></template
            >
            <el-button
              v-if="!isMobile()"
              icon="el-icon-printer"
              size="small"
              type="primary"
              plain
              @click="quotationPreviewVisibile = true"
              >预览</el-button
            >
            <el-button
              icon="el-icon-edit"
              size="small"
              type="success"
              plain
              v-if="order.deleted == 1"
              @click="recoveryOrder()"
              v-permission="Auth.orderRecovery"
              >恢复</el-button
            >
            <el-dropdown
              v-if="
                order.status == 1 || order.status == 4 || order.status == 100
              "
              v-permission="Auth.orderContract"
              @command="handleContractExport"
            >
              <el-button size="small" type="primary" class="ml-10" plain
                >{{ order.status == 1 ? '报价单' : '合同' }}导出<i
                  class="el-icon-arrow-down el-icon--right"
                ></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">销售报价单</el-dropdown-item>
                <!-- <el-dropdown-item command="2">现场维修合同书</el-dropdown-item>
                <el-dropdown-item command="3">维修合同书</el-dropdown-item>
                <el-dropdown-item command="4"
                  >原厂基本维修服务合同</el-dropdown-item
                >
                <el-dropdown-item command="5"
                  >原厂维护保养合同</el-dropdown-item
                >
                <el-dropdown-item command="6"
                  >原厂翻新服务合同</el-dropdown-item
                > -->
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              class="ml-10"
              size="small"
              type="primary"
              plain
              v-if="order.status == 4"
              @click="finishOrder()"
              v-permission="Auth.orderFinish"
              >完成</el-button
            >
            <template v-if="canSubmitApproval">
              <el-button
                icon="el-icon-check"
                class="ml-10"
                type="primary"
                size="small"
                round
                @click="submitApproval()"
                :disabled="submiting"
                v-permission="Auth.orderNew"
                >提交审核</el-button
              >
            </template>
          </div>
        </div>
      </div>
      <el-form
        :model="order"
        label-position="right"
        size="mini"
        label-width="110px"
        class="mobile-inline"
      >
        <el-form-item label="金额：">
          <div class="text-danger font-weight-bolder font-14">
            ￥{{ math.show(order.order_info.amount) }}
          </div>
        </el-form-item>
        <el-form-item label="创建人：">
          {{ order.user.name || order.customer_user.name }}
        </el-form-item>
        <el-form-item label="创建时间：">
          <div>
            {{ $time(new Date(order.created_at)).format('YYYY-MM-DD HH:mm') }}
          </div>
        </el-form-item>
        <el-form-item label="报价类型：">
          <div>
            {{ order.order_info.type == 2 ? '服务报价' : '备件报价' }}
          </div>
        </el-form-item>
        <el-form-item label="客户名称：">
          <customer-link :customer="order.customer"></customer-link>
        </el-form-item>
        <el-form-item label="项目信息：">
          {{ order.order_info.project_name }}
          <template v-if="order.order_info.customer_contact_id > 0">
            （{{ order.order_info.customer_contact.name }}
            {{ order.order_info.customer_contact.mobile }}）
          </template>
        </el-form-item>
        <el-form-item
          label="最终用户："
          v-if="order.order_info.install_customer_id"
        >
          <customer-link
            :customer="order.order_info.install_customer"
          ></customer-link>
        </el-form-item>
        <el-form-item
          label="机会种类："
          v-if="order.order_info.business_opportunity_type"
        >
          <BusinessOpportunitySelector
            :val="order.order_info.business_opportunity_type"
          ></BusinessOpportunitySelector>
        </el-form-item>
        <el-form-item
          label="业务机会编号："
          v-if="order.order_info.business_chance_number"
        >
          {{ order.order_info.business_chance_number }}
        </el-form-item>
        <!-- <el-form-item label="报价单：" v-if="order.quotation.id > 0">
          <quotation-link
            :quotation="order.quotation"
            :origin="2"
            :styled="true"
          ></quotation-link>
        </el-form-item> -->
        <el-form-item label="收货信息：">
          <div class="receive-info">
            <span class="mr-20">{{
              showParam(order.order_info.shipping_address)
            }}</span>
            <span class="mr-20">{{
              showParam(order.order_info.consignee_name)
            }}</span
            ><span class="mr-20">{{
              showParam(order.order_info.consignee_mobile)
            }}</span>
          </div>
        </el-form-item>
        <el-form-item label="收票信息：">
          <div class="receive-info">
            <span class="mr-20">{{
              showParam(order.order_info.invoice_shipping_address)
            }}</span>
            <span class="mr-20">{{
              showParam(order.order_info.invoice_consignee_name)
            }}</span
            ><span class="mr-20">{{
              showParam(order.order_info.invoice_consignee_mobile)
            }}</span>
            <span class="mr-20">{{
              showParam(order.order_info.invoice_consignee_email)
            }}</span>
          </div>
        </el-form-item>
        <el-form-item label="发票信息：">
          <div class="receive-info">
            {{ showParam(order.order_info.invoice.title) }}
          </div>
        </el-form-item>
        <el-form-item label="补充信息：" v-if="order.order_info.remark">
          <div>{{ order.order_info.remark }}</div>
        </el-form-item>
      </el-form>
    </div>

    <div class="panel mt-20" v-if="order && order.flow_id">
      <p>审批流程</p>
      <div class="mb-20 mobile-scroll-x">
        <div class="mt-10" :class="{ 'flex-row-between': !isMobile() }">
          <el-steps
            v-if="order.approvers"
            simple
            :active="order.approve_index"
            finish-status="success"
            :style="'width:' + order.approvers.length * 160 + 'px'"
          >
            <el-step
              v-for="(user, index) in order.approver_names"
              :key="index"
              :title="user"
              :status="
                order.status == 3 && index + 1 == order.approve_index
                  ? 'error'
                  : ''
              "
            ></el-step>
          </el-steps>
        </div>
      </div>
      <template v-if="canApproval">
        <el-button
          type="primary"
          size="small"
          @click="submitApprovalResult(true)"
          :disabled="submiting"
          v-permission="Auth.orderApprove"
          >审批通过</el-button
        >
        <el-button
          type="danger"
          size="small"
          @click="submitApprovalResult(false)"
          :disabled="submiting"
          v-permission="Auth.orderApprove"
          >不通过</el-button
        >
      </template>
    </div>

    <OrderFlow
      v-if="order && order.flows"
      :order="order"
      @approved="handleApproved"
    ></OrderFlow>

    <template v-if="order">
      <div class="panel mt-20">
        <el-tabs v-model="activeTab" @tab-click="clickedTab">
          <el-tab-pane label="总览" name="tab1" v-if="hasAuth('orderOverview')">
            <div v-show="activeTab == 'tab1'">
              <div class="mt-20">
                <div class="header">
                  <h2>产品信息</h2>
                </div>
                <template v-if="order.order_info.products.length > 0">
                  <el-table
                    v-if="!isMobile()"
                    :data="order.order_info.products"
                    style="width: 100%"
                    key="order_info.products"
                  >
                    <el-table-column prop="item.name" label="产品件号">
                      <template slot-scope="scope">
                        <span>{{ scope.row.item.part_number }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="item.description" label="描述">
                    </el-table-column>
                    <el-table-column
                      prop="item.price"
                      label="价格(￥)"
                      width="160"
                    >
                      <template slot-scope="scope">
                        <div>{{ scope.row.price }}</div>
                        <div class="price-info">
                          <span>
                            原价：{{ scope.row.item.price }} (
                            {{
                              priceIncreasePercent(
                                scope.row.item.price,
                                scope.row.price
                              )
                            }}%)
                          </span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="count"
                      label="数量"
                      width="80"
                      align="center"
                    ></el-table-column>
                  </el-table>
                  <item-list-mobile
                    v-else
                    :items="order.order_info.products"
                  ></item-list-mobile>
                </template>
                <ul class="devices">
                  <li
                    v-for="(device, index) in order.order_info.devices"
                    :key="device.id"
                    class="mt-10"
                  >
                    <div class>
                      <div class="flex-row device-tags">
                        <span class="c-tag c-tag-main"
                          >设备：{{
                            device.customer_device.serial_number || '无'
                          }}</span
                        >
                      </div>
                    </div>
                    <el-table
                      :data="device.items"
                      style="width: 100%"
                      :key="'device.items' + index"
                    >
                      <!-- <el-table-column
                        prop="item.name"
                        label="产品名称"
                      ></el-table-column> -->
                      <el-table-column
                        prop="item.part_number"
                        label="产品件号"
                      ></el-table-column>
                      <el-table-column prop="item.description" label="描述">
                      </el-table-column>
                      <el-table-column
                        prop="item.price"
                        label="价格(￥)"
                        width="160"
                      >
                        <template slot-scope="scope">
                          <div>{{ scope.row.price }}</div>
                          <div class="price-info">
                            <span>
                              原价：{{ scope.row.item.price }} (
                              {{
                                priceIncreasePercent(
                                  scope.row.item.price,
                                  scope.row.price
                                )
                              }}%)
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="count"
                        label="数量"
                        width="80"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <span>
                            {{ scope.row.count }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </li>
                </ul>
                <div class="header mt-20">
                  <h2>费用合计</h2>
                </div>
                <div class="settle mt-20">
                  <ul class="fee-list">
                    <li>
                      <div class="title">小计</div>
                      <div class="input"></div>
                      <div class="amount">{{ math.show(displayFee.item) }}</div>
                    </li>
                    <li>
                      <div class="title">税费（13%）</div>
                      <div class="input"></div>
                      <div class="symbol">+</div>
                      <div class="amount">{{ math.show(displayFee.tax) }}</div>
                    </li>
                    <li>
                      <div class="title">杂项</div>
                      <div class="input"></div>
                      <div class="symbol">+</div>
                      <div class="amount">
                        {{ math.show(displayFee.labor) }}
                      </div>
                    </li>
                    <li>
                      <div class="title">折扣金额（含税）</div>
                      <!-- <div class="input">
                        约{{ math.show(displayFee.discount) }}%
                      </div> -->
                      <div class="symbol">-</div>
                      <div class="amount">
                        {{ math.show(displayFee.discount_value) }}
                      </div>
                    </li>
                    <li>
                      <div class="title">最终折扣</div>
                      <div class="amount">
                        {{ math.show(displayFee.discount) }}%
                      </div>
                    </li>
                    <li>
                      <div class="title">合计</div>
                      <div class="input"></div>
                      <div class="amount">
                        {{ math.show(order.order_info.amount) }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="合同"
            name="tab2"
            v-if="hasAuth('orderAgreement')"
          >
            <contract-tab
              v-if="order.status == 4 || order.status == 100"
              :show="activeTab == 'tab2'"
              :order.sync="order"
            ></contract-tab>
            <p class="text-center font-12 mt-20" v-else>审批通过后可添加</p>
          </el-tab-pane>
          <el-tab-pane label="操作记录" name="tab6" v-if="hasAuth('orderLog')">
            <log-tab
              :show="activeTab == 'tab6'"
              :customerOrderID="order.id"
            ></log-tab>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
    <quotation-preview
      :show.sync="quotationPreviewVisibile"
      :quotation="order"
      :print="true"
      :fee="displayFee"
    ></quotation-preview>
  </div>
</template>

<script>
import { numberMul, formatTime, priceIncreasePercent } from '@/util/index'
import {
  customerOrderDetail,
  createPurchaseOrder,
  customerOrderConfirm,
  customerOrderLogList,
  deleteCustomerOrder,
  submitApproveCustomerOrder,
  approveCustomerOrder,
  itemCostPrice,
  deleteOrderCost,
  customerCollectionList,
  recoveryCustomerOrder,
  finishCustomerOrder,
  customerOrderContractExport,
} from '../../service/getData'
import { clone } from '@/util'
import {
  CustomerOrderStatusMap,
  CustomerOrderLogMap,
  PurchaseOrderStatusMap,
  ShippingRecordStatusMap,
} from '@/config/global'
import FlowSelector from '@/components/flow_selector'
import ContractTab from './contract'
import CostAndCollectionTab from './cost_and_collection'
import InvoiceRecordTab from './invoice_record'
import PurchaseAndShippingTab from './purchase_and_shipping'
import LogTab from './log'
import ItemListMobile from '../../views/quotation/item_list_mobile'
import QuotationPreview from '@/components/quotation_preview'
import OrderFlow from './OrderFlow.vue'

import { hasAuth } from '@/permission'
import { host } from '@/config/env'

import {
  DisplayOrderFee,
  CalculateProfit,
  AutoOrderInfoFlow,
} from '../../util/order_calculate'

import store from '@/store/store'
import auth from '@/util/auth'
import math from '@/util/math'
import { isMobile } from '../../util'

export default {
  components: {
    OrderFlow,
    FlowSelector,
    ContractTab,
    CostAndCollectionTab,
    InvoiceRecordTab,
    PurchaseAndShippingTab,
    ItemListMobile,
    LogTab,
    QuotationPreview,
  },
  data() {
    return {
      quotationPreviewVisibile: false,
      host,
      hasAuth,
      isMobile,
      activeTab: 'tab1',
      id: parseInt(this.$route.params.id),
      origin: parseInt(this.$route.query.origin),
      order: null,
      loading: false,
      purchaseOrderVisible: false,
      stockOutVisible: false,
      flowSelectorVisibile: false,
      numberMul: numberMul,
      submiting: false,
      purchaseItems: [],
      priceIncreasePercent,
      formatTime: formatTime,
      purchaseOrders: [],
      shippingRecordForm: {},
      shippingRecordVisible: false,
      orderStatusMap: CustomerOrderStatusMap,
      auth,
      math,
      collections: [],
      purchaseOrderForm: {},
      stockOutForm: {},
      PurchaseOrderStatusMap,
      ShippingRecordStatusMap,
      shippingRecordEditIndex: -1,
      userInfo: store.getters.userInfo,
      selectedShippingRecord: null,
      selectedPurchaseOrder: null,
      purchaseOrderDetailVisible: false,
      itemCostPrices: [],
      profit: '计算中...',
      profit_rate: 0,
      actualProfit: 0,
      orderInfoFlow: null,
      editOrderCostIndex: 0,
      cost: 0,
      displayFee: {
        item: 0,
        tax: 0,
        labor: 0,
        discount: 0,
        total: 0,
      },
    }
  },
  computed: {
    canEdit() {
      return (
        this.order.deleted == 0 &&
        (this.order.status == 1 || this.order.status == 3)
      )
    },
    canSubmitApproval() {
      return (
        this.order.deleted == 0 &&
        (this.order.status == 1 || this.order.status == 3) &&
        (this.order.user_id == this.userInfo.id ||
          this.order.customer_user_id > 0)
      )
    },
    canApproval() {
      return (
        this.order.deleted == 0 &&
        this.order.status == 2 &&
        this.order.flow_id > 0 &&
        this.order.approvers[this.order.approve_index] == this.userInfo.id
      )
    },
    parentRouter() {
      if (this.order.deleted == 1) {
        return {
          path: `/dashboard/${
            this.order.customer_user_id > 0 ? 'customer' : 'dealer'
          }/deleted/orders`,
          name: '已删除报价单',
        }
      }
      if (this.order.status == 100) {
        return {
          path: `/dashboard/${
            this.order.customer_user_id > 0 ? 'customer' : 'dealer'
          }/done/orders`,
          name: '已完成报价单',
        }
      }
      return {
        path: `/dashboard/${
          this.order.customer_user_id > 0 ? 'customer' : 'dealer'
        }/orders`,
        name: '进行中报价单',
      }
    },
  },
  watch: {},
  beforeRouteUpdate(to, from, next) {
    if (parseInt(to.params.id) != this.id) {
      this.activeTab = null
      this.id = parseInt(to.params.id)
      setTimeout(this.ready, 50)
    }
    next()
  },
  created() {
    this.ready()
  },
  methods: {
    ready() {
      this.activeTab = 'tab' + (this.$route.query.tab || 1)
      this.requestOrderDetail()
    },
    async requestOrderDetail() {
      this.loading = true
      let res = await customerOrderDetail(this.id)
      if (res.code == 0) {
        if (res.data.approver_names) {
          res.data.approver_names_html = res.data.approver_names.join(
            ' <i class="el-icon-right"></i> '
          )
        }
        this.order = res.data
        this.purchaseOrders = res.data.purchase_orders

        let purchaseItems = []
        this.order.order_info.devices.map((d) => {
          d.items.map((i) => {
            let purchaseCount = this.order.store_info[i.item.id]
            if (purchaseCount > 0) {
              let pi = {}
              pi.item_id = i.item.id
              pi.count = purchaseCount
              pi.item = i.item
              purchaseItems.push(pi)
            }
          })
        })

        this.order.order_info.products.map((p) => {
          let purchaseCount = this.order.store_info[p.item_id]
          if (purchaseCount > 0) {
            let pi = {}
            pi.item_id = p.item_id
            pi.count = purchaseCount
            pi.item = p.item
            purchaseItems.push(pi)
          }
        })
        this.purchaseItems = purchaseItems
        this.order.collection_percentage =
          this.order.order_info.amount == 0
            ? 0
            : Math.min(
                parseInt(
                  (this.order.collection_total / this.order.order_info.amount) *
                    100
                ),
                100
              )

        this.recalculateItemFee()
      }
      this.loading = false
    },

    async handleContractExport(t = 0) {
      let res = await customerOrderContractExport({
        id: this.order.id,
        contract_type: t,
      })
      if (res.code == 0) {
        let href = res.data
        window.location.href = href
      }
    },

    recalculateItemFee() {
      this.displayFee = DisplayOrderFee(this.order.order_info)

      let that = this

      CalculateProfit(this.order.order_info, function (profit, profitRate) {
        that.profit = profit
        that.profit_rate = profitRate
      })

      AutoOrderInfoFlow(
        this.order.order_info,
        this.oils,
        function (orderInfoFlow) {
          that.orderInfoFlow = orderInfoFlow
        }
      )
    },
    recalculateCost(orderCosts) {
      let cost = this.order.order_info.item_cost
      orderCosts.map((oc) => {
        cost = math.add(cost, oc.amount)
      })
      this.cost = cost

      let amount = math.multiply(
        this.order.order_info.itemFee,
        1 - (this.order.order_info.discount || 0) / 100
      )
      amount = math.add(amount, this.order.order_info.labor_fee)
      let profit = math.subtract(amount, cost)
      this.actualProfit = profit
    },
    submitApproval() {
      let that = this
      this.$confirm('是否确定提交审批?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        submitApproveCustomerOrder({ customer_order_id: that.order.id }).then(
          (res) => {
            if (res.code == 0) {
              if (res.data.approver_names) {
                that.order.approver_names_html = res.data.approver_names.join(
                  ' <i class="el-icon-right"></i> '
                )
              }

              that.order.flow_id = res.data.flow_id
              that.order.flow_name = res.data.flow_name
              that.order.approvers = res.data.approvers
              that.order.approve_index = 0
              that.order.approver_names = res.data.approver_names
              that.order.flow = res.data.flow
              that.order.flows = res.data.flows
              that.order.status = res.data.status
              that.$message({
                message: res.data.status == 100 ? '审批通过' : '提交成功',
                type: 'success',
              })

              if (res.data.status == 100) {
                that.$router.push(
                  `/dashboard/${
                    that.order.customer_user_id > 0 ? 'customer' : 'dealer'
                  }/done/orders/` + that.order.id
                )
              }
            }
          }
        )
      })
    },
    submitApprovalResult(result) {
      let that = this
      this.$confirm(
        '是否确定提交审批结果：' + (result ? '通过' : '不通过'),
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        approveCustomerOrder({ id: that.order.id, result: result }).then(
          (res) => {
            if (res.code == 0) {
              that.order.status = res.data.status
              that.order.approve_index = res.data.approve_index
            }
          }
        )
      })
    },
    handleApproved(order) {
      this.order.status = order.status
      this.order.flows = order.flows
    },
    confirmPurchaseOrder(result, tips) {
      let that = this
      let title = '确认' + tips + '？'
      this.$confirm(title, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        that.submiting = true
        let data = {
          id: that.id,
          result: result,
        }
        customerOrderConfirm(data).then((res) => {
          if (res.code == 0) {
            that.order.status = res.data.status
          }
          that.submiting = false
        })
      })
    },
    postPurchaseOrder() {
      let that = this
      this.$confirm('是否确认生成采购单?', '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        that.submiting = true
        let data = {
          customer_order_id: that.order.id,
          items: that.purchaseItems,
          type: 2,
        }
        createPurchaseOrder(data).then((res) => {
          if (res.code == 0) {
            that.purchaseOrder = res.data
          }
          that.submiting = false
        })
      })
    },

    deleteOrder() {
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCustomerOrder(that.order.id).then((res) => {
          if (res.code == 0) {
            that.order.deleted = 1
            that.$router.push(
              `/dashboard/${
                that.order.customer_user_id > 0 ? 'customer' : 'dealer'
              }/deleted/orders/` + that.order.id
            )
          }
        })
      })
    },
    recoveryOrder() {
      let that = this
      this.$confirm('是否确定恢复?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        recoveryCustomerOrder(that.order.id).then((res) => {
          if (res.code == 0) {
            that.order.deleted = 0
            that.$router.push(
              `/dashboard/${
                that.order.customer_user_id > 0 ? 'customer' : 'dealer'
              }/orders/` + that.order.id
            )
          }
        })
      })
    },
    finishOrder() {
      let that = this
      this.$confirm('确定完成吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        finishCustomerOrder(that.order.id).then((res) => {
          if (res.code == 0) {
            that.order.status = 100
            that.$router.push(
              `/dashboard/${
                that.order.customer_user_id > 0 ? 'customer' : 'dealer'
              }/done/orders/` + that.order.id
            )
          }
        })
      })
    },
    async selectedFlow(flow_id) {
      if (!flow_id || flow_id == 0) {
        return
      }
      let data = {
        customer_order_id: this.order.id,
        flow_id: flow_id,
      }

      let res = await submitApproveCustomerOrder(data)
      if (res.code == 0) {
        this.order.flow_id = res.data.flow_id
        this.order.flow = res.data.flow
        this.order.status = res.data.status
        this.$message({
          message: '提交成功',
          type: 'success',
        })
      }
    },
    startFlowSelector() {
      if (this.order.contracts.length == 0) {
        this.$alert('请先添加合同', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        })
      } else {
        this.flowSelectorVisibile = true
      }
    },
    clickedTab(e) {
      const index = parseInt(e.index)
      this.$router.replace({ query: { tab: index + 1 } })
    },
    showParam(param, date) {
      if (param && param.length > 0) {
        if (date) {
          return formatTime(param)
        }
        return param
      } else {
        return '未设置'
      }
    },
  },
}
</script>

<style scoped>
.order-option-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
/deep/.el-form-item--mini {
  margin-bottom: 0px;
}
/deep/.el-form-item--mini .el-form-item__label,
/deep/.el-form-item--mini .el-form-item__content {
  font-size: 13px;
}
.sub-info {
  border: 0 none;
}
.device-tags span {
  margin-right: 10px;
}

.item-list li {
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.item-list li:last-child {
  border: 0 none;
}
.order-info {
}
.order-info .title {
  font-size: 12px;
  color: #999;
}

.logs li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 8px 0;
}
.logs li:last-child {
  border-bottom: 0 none;
}
.logs p {
  margin: 0 0 5px 0;
}
.logs p:nth-child(2) {
  font-size: 12px;
}
.logs p:last-child {
  margin: 0;
}

.steps {
  display: flex;
  justify-content: space-between;
  height: 60px;
  justify-items: center;
  border-radius: 6px;
  background-color: #fafafa;
  margin-top: 10px;
}

.step-item {
  width: 125px;
  padding: 0 10px;
  color: rgba(90, 99, 126, 0.49);
  padding-top: 15px;
}
.step-item-link {
  flex: 1;
  font-size: 12px;
  text-align: center;
  position: relative;
}
.step-item-link span:first-child {
  display: block;
  margin-top: 10px;
  color: rgba(90, 99, 126, 0.49);
}
.step-item-link .line {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  margin-top: -7px;
  height: 14px;
  font-size: 15px;
  color: #bbb;
}

.step-item-link .line::before {
  content: '';
  position: absolute;
  left: 0;
  right: 6px;
  top: 7px;
  height: 1px;
  background: #bbb;
}

.step-item-link .line i {
  float: right;
}

.step-item-link.past span:first-child {
  color: #3e4b5b;
}

.step-item.current {
  color: #047bf8;
}

.step-item.past {
  color: #3e4b5b;
}

.step-item.current .number {
  border-color: #047bf8;
  background-color: #047bf8;
  color: #fff;
}

.step-item.past .number {
  border-color: #666;
  color: #323232;
}

.step-item .number {
  border: 2px solid rgba(90, 99, 126, 0.49);
  margin-right: 5px;
  display: inline-block;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  line-height: 26px;
  background-color: transparent;
  box-sizing: border-box;
}

.other-infos li.sub-info {
  display: flex;
}

.other-infos li.sub-info .sub-info-label {
  font-size: 14px;
  width: 100px;
}
.other-infos li.sub-info .sub-info-value {
  flex: 1;
}
</style>

<style  scoped>
@media (max-width: 767px) {
  .steps {
    flex-wrap: wrap;
    height: auto;
    padding: 5px;
  }
  .step-item {
    padding: 0 5px;
    margin: 10px 0;
    width: auto;
  }
  .step-item .number {
    width: 20px;
    height: 20px;
    line-height: 18px;
    font-size: 12px;
  }
  .steps .step-item-link {
    margin: 0 5px;
    flex: auto;
  }

  .step-item-link span:first-child {
    margin-top: 0;
  }
}
</style>